import { size } from 'lodash';
import React, { ComponentProps, FC } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FaSignOutAlt } from 'react-icons/fa';

type Props = ComponentProps<typeof Button>;

export const ButtonLogout: FC<Props> = (props) => {
  const { t, i18n } = useTranslation();
  return (
    <Button
      {...props}
      // style={{ width: '160px' }}
      style={{ color: 'white', fontSize: '0.9rem', textDecoration: 'none' }}
      variant="link"
      onClick={props.onClick}
    >
      <FaSignOutAlt size="1.1rem" className="mb-1" />{' '}
      {t(props?.text ?? i18n.language === 'gr' ? t('Αποσύνδεση') : 'Logout')}
    </Button>
  );
};
